import React from 'react'

const java = {
    id:  'indonesia-east-java',
    type: 'post',
    countryId: 'mAndI',
    title: 'Definitely Off the Beaten Path in East Java',
    longDate: 'May 27, 2019',
    month: 'May',
    date: '27',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/eastjavacover.jpg',
    content: [
        {
            text: (
                <div>Indonesia is big. Really, really big. Here's how large it is compared to the U.S.:</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/IndonesiavsUS.jpg',
            detailText:(<a href="https://www.mylifeelsewhere.com/country-size-comparison/united-states/indonesia">Source</a>)
        },
        {
            text: (
                <div>The U.S. is about 5 times larger by land mass, but Indonesia spans almost the entire length of the continental states! When we were in Malaysia, planning how to make our way across the country, I first looked at taking a ferry from Singapore (on the tip of the Malaysia peninsula) to Sumatra, then going by train down that island and through Java. Wrong. That journey would have taken over 30 hours. It feels more backpacker-y to go by bus and train everywhere, and it would have been an adventure, but as we learned <a href="https://worldofwander.app/post/langkawi">earlier in our trip</a>, it's really nice to slow down and not be constantly trying to move to the next spot.</div>
            )
        },
        {
            text: (
                <div>So we flew into Surabaya, for the sole purpose of getting to Tumpak Sewu, an incredible circular crater-like waterfall. I had seen it in just a few photos on Instagram, and only referenced one blog post on how to get there, but still we had assumed there would be tons of tourists. This time, we were completely alone.</div>
            )
        },
        {
            text: (
                <div>We got up before sunrise to get the best view of the waterfall (this would become a pattern). No one else was on the viewing platform, and we watched in awe as the sun slowly rose behind Semuru volcano. We could even see a little puff of volcanic ash rising from the top.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/tumpaksewu.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/tumpaksewu2.jpg'
        },
        {
            text: (
                <div>Next, we decided to hike down to the bottom, hoping to see the rays of sun slowly fill up the crater bottom. Imagine a steep jungle hill with a bamboo staircase strapped on, broken and hanging off in a few spots, and you get the picture. Later in the day we saw a group of Indonesian guys scamper down in flip flops, and I honestly don't know how they didn't die.</div>
            )
        },
        {
            text: (
                <div>Sadly at the bottom, the heavy rains had flooded the river bed and washed away the bridge to get to the base of the falls. So instead, we walked along the river to Goa Tetes, a section of the falls that runs over red stone – though again, it was flooded and we couldn't get all the way to the main attraction. Other people probably went across barefoot or in sandals, but we had on hiking boots. If we'd learned one thing from Iceland, it was to never do a barefoot river crossing – and that was in a shallow river with tons of people around and easy access out, unlike this spot. Indonesia has few safety standards and if you want to come out in one piece, you have to make your own. We heard too many sad stories of adventurous travelers dying abroad to be truly risky.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/goatetes.jpg'
        },
        {
            text: (
                <div>That afternoon, we motorbiked a little way up the road to another waterfall, Air Terjun Kapas Biru. Again, we were the only people there – and by the looks of it, the only people who had been in weeks. We walked down the stairway to the first viewpoint, mostly obscured by quickly growing trees, and after that the path completely disappeared into jungle. We had decided on flip flops this time, and during the few minutes we stood in calf-high grass debating whether to continue, a leech attached itself to Peter's foot. But we had a surprise at the top: following a sign down a side path with the name of another Terjun ("waterfall"), we came across a beautiful hidden garden-esque river with small falls and pools. It was gorgeous, and we spent an hour just hanging out and truly enjoying Indonesian nature.</div>
            )
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/javawaterfall4.jpg','https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/javawaterfall3.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/javawaterfall.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/javawaterfall2.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/ricepaddies.jpg'
        },
        {
            text: (
                <div>We were so obsessed with Tumpak Sewu – officially crowned our top waterfall after a year of seeing a LOT of waterfalls – that Peter wanted to go back for another look that afternoon. It made me so, so glad we had done it at sunrise the first time, because the daytime was washed out and less pretty.</div>
            )
        },
        {
            text: (
                <div>At this point our lack of planning caught up with us. We had decided against renting a car in Surabaya to drive out to Tumpak Sewu, because we were going one way down Java to catch the ferry into Bali. We'd heard that police do extra car checks for tourists here, and there's a highway system with automatic tolls that's easy to mess up and get fined for – it sounded like too much hassle. (Also, you're supposed to have an international driver's license for these things – and not having one will almost certainly result in needing to bribe.)</div>
            )
        },
        {
            text: (
                <div>So instead our first homestay, Dear Traveller Guest House and Glamping, picked us up at the airport – and then we were stranded out in the middle of Java with no accessible bus system. The homestay offered to drive us around to the other sights we wanted to see, and we worked out a price for two nights and stops at two volcanos. Then, half an hour before we were leaving, the price was doubled – of course in a roundabout way where they insisted that it had been the price all along and we had misunderstood. We had no other options so went along with it. Both of us dislike traveling with a private driver and guide; you lose control over the itinerary and schedule. It cost the same as a one-way car rental would have, with less hassle, but if I were to do it again I'd rent.</div>
            )
        },
        {
            text: (
                <div>While the remoteness, lack of accessibility to attractions, and difficulty finding food made Java a difficult place to be a tourist, we absolutely loved all the natural wonders. From Tumpak Sewu, we left at midnight to drive north to Mount Bromo and hike to the viewpoint for sunrise. Like Semuru, this volcano slowly and constantly spat out ash. <a href="https://photos.app.goo.gl/ZU5t7zzhSzFtQAFc7">Here's a timelapse I took!</a> The people in the nearby village had to sweep constantly and a lot of them wore cloths over their mouths when outside. Hilariously, we saw one guy budge the cloth over to take a long drag off a cigarette. Generally, everyone smoked like chimneys. Save your lungs one way, kill them another?</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/bromo1.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/bromo2.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/bromo3.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/bromo4.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/bromo5.jpg'
        },
        {
            text: (
                <div>After our sunrise at Bromo, we napped in the car while driving east to Mount Ijen, famous for its blue flames. Again, we woke up just after midnight and started hiking to the top. There were tons of people on the path – even some older people who hired men to push them up to the top in carts. Very few of the tourists were Westerners - it was mostly people from other parts of Indonesia, and across Asia.</div>
            )
        },
        {
            text: (
                <div>A third night of lost sleep was 100% worth it for those blue flames. It's caused by sulfur, and can only be seen when glowing in the dark – in the daytime, all you see is the yellow sulfuric rocks and gas. After staring captivated at the flames for 20 minutes, we left to get some fresh air and find a spot along the edge of the crater before sunrise. The view was truly incredible.</div>
            )
        },
        {
            text: (
                <div>Our four days in Java were short, but we crammed a ton in – and including the first day with a morning flight, our wake up calls were 4 am, 5 am, 12 am, and 1 am. It was time to head over to Bali and completely blob for a week in a nice hotel.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/bluefire.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/ijen1.jpg'
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/ijen2.jpg','https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/ijen3.jpg']
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/ijen4.jpg'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/mAndI/indonesia-east-java/ijen5.jpg'
        },
]
}

export default java


// WEBPACK FOOTER //
// ./src/Posts/Content/Java.js